import { render, staticRenderFns } from "./EmptyDetail.vue?vue&type=template&id=3788590e"
import script from "./EmptyDetail.vue?vue&type=script&lang=js"
export * from "./EmptyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports